import React, { useState } from 'react';
import { X } from 'lucide-react';
import { collection, addDoc } from "firebase/firestore";

const modalOverlayStyle = { position: 'fixed', top:0, left:0, right:0, bottom:0, backgroundColor: 'rgba(0,0,0,0.5)', display:'flex', justifyContent:'center', alignItems:'center', zIndex: 1000 };
const modalContentStyle = { backgroundColor: 'white', width: '700px', maxWidth:'95%', borderRadius: '8px', padding: '20px', display:'flex', flexDirection:'column', position: 'relative' };
const rowStyle = { display: 'flex', gap: '15px', marginBottom: '15px' };
const labelStyle = { display: 'block', fontSize: '11px', fontWeight: '600', color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase' };
const inputStyle = { width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #d1d5db', fontSize: '13px', boxSizing: 'border-box' };
const btnPrimaryStyle = { backgroundColor: '#2563eb', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' };

export const NewVendorModal = ({ show, onClose, onSave, db }) => {
  const [newVendor, setNewVendor] = useState({
    name: '',
    code: '',
    type: 'Supplier', // Supplier, Transporter
    status: 'Active',
    contactPerson: '',
    phone: '',
    altPhone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    gstNo: '',
    remarks: ''
  });

  if (!show) return null;

  const handleChange = (e) => setNewVendor({ ...newVendor, [e.target.name]: e.target.value });

  const saveVendor = async () => {
    if (!newVendor.name || !newVendor.code) return alert("Vendor Name and Code are required.");
    
    try {
      const docRef = await addDoc(collection(db, "vendors"), {
        ...newVendor,
        createdAt: new Date().toISOString()
      });
      const savedVendor = { id: docRef.id, ...newVendor };
      onSave(savedVendor);
      onClose();
    } catch (e) {
      console.error("Error saving vendor:", e);
      alert("Error saving vendor");
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '15px', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>New Vendor</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer' }}><X size={24} /></button>
        </div>

        <div style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: '10px' }}>
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Vendor Name *</label><input name="name" value={newVendor.name} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>Vendor Code *</label><input name="code" value={newVendor.code} onChange={handleChange} style={inputStyle} /></div>
          </div>
          
          <div style={rowStyle}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Vendor Type</label>
              <select name="type" value={newVendor.type} onChange={handleChange} style={inputStyle}>
                <option value="Supplier">Supplier</option>
                <option value="Transporter">Transporter</option>
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Status</label>
              <select name="status" value={newVendor.status} onChange={handleChange} style={inputStyle}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Contact Person</label><input name="contactPerson" value={newVendor.contactPerson} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>Phone Number</label><input name="phone" value={newVendor.phone} onChange={handleChange} style={inputStyle} /></div>
          </div>

          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>Alternate Phone</label><input name="altPhone" value={newVendor.altPhone} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>Email</label><input name="email" value={newVendor.email} onChange={handleChange} style={inputStyle} /></div>
          </div>

          <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Address</label><textarea name="address" value={newVendor.address} onChange={handleChange} style={{ ...inputStyle, minHeight: '60px' }} /></div>
          
          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>City</label><input name="city" value={newVendor.city} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>State</label><input name="state" value={newVendor.state} onChange={handleChange} style={inputStyle} /></div>
            <div style={{ flex: 1 }}><label style={labelStyle}>PIN Code</label><input name="pincode" value={newVendor.pincode} onChange={handleChange} style={inputStyle} /></div>
          </div>

          <div style={rowStyle}>
            <div style={{ flex: 1 }}><label style={labelStyle}>GST No.</label><input name="gstNo" value={newVendor.gstNo} onChange={handleChange} style={inputStyle} /></div>
          </div>

          <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Remarks</label><textarea name="remarks" value={newVendor.remarks} onChange={handleChange} style={{ ...inputStyle, minHeight: '40px' }} /></div>
        </div>
        
        <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 20, paddingTop: 15, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
           <button onClick={onClose} style={{ padding: '8px 15px', border: '1px solid #d1d5db', background: 'white', borderRadius: 5, cursor:'pointer' }}>Cancel</button>
           <button onClick={saveVendor} style={btnPrimaryStyle}>Save Vendor</button>
        </div>
      </div>
    </div>
  );
};
